import React, { Component } from "react";
import PageStatistics from "../components/PageStatistics";
import { datesAreDiff } from "../utils/datesAreDiff";
import MessageBar from "../components/MessageBar";

const runningLocal = process.env.REACT_APP_API_DOMAIN !== "sc";
const MatrixService = runningLocal
  ? require("../data/MatrixService.dev").default
  : require("../data/MatrixService.prod").default;

class Matrix extends Component {
  state = {
    data: null
  };

  shouldComponentUpdate(nextProps, nextState) {
    //debugger;

    if (this.state.data == null && nextState.data !== null) {
      return true;
    }

    // TODO: totalRecordCount doesn't guarantee that new data is fetched
    // this shouldn't be an issue after we bring proper state management
    if (
      this.state.data &&
      this.state.data.totalRecordCount !== nextState.data.totalRecordCount
    ) {
      return true;
    }

    if (this.props.site !== nextProps.site) {
      return true;
    }

    if (this.props.filters !== nextProps.filters) {
      return true;
    }

    if (this.props.category !== nextProps.category) {
      return true;
    }

    if (datesAreDiff(this.props.dateRange.start, nextProps.dateRange.start)) {
      return true;
    }

    if (datesAreDiff(this.props.dateRange.end, nextProps.dateRange.end)) {
      return true;
    }

    return false;
  }

  componentDidMount() {
    this.update();
  }

  filter(filters, originalData) {
    if (!filters || filters.length <= 0 || filters[0] === "All") {
      return originalData.data.content;
    }

    const keys = originalData.data.localization.fields.filter(
      f => f.field === "key"
    );

    let translatedKeys = null;
    if (keys && keys.length > 0) {
      translatedKeys = keys[0].translations;
    }

    if (!translatedKeys) {
      throw "no keys present for filtering";
    }

    const matches = [];
    for (let key in translatedKeys) {
      const value = translatedKeys[key];
      const match = filters.some(item => value.match(item) != null);
      if (match) {
        matches.push(key);
      }
    }

    return originalData.data.content.filter(e => matches.includes(e.key));
  }

  componentDidUpdate(prevProps) {
    console.log("Matrix: componentDidUpdate");
    const update =
      datesAreDiff(this.props.dateRange.start, prevProps.dateRange.start) ||
      datesAreDiff(this.props.dateRange.end, prevProps.dateRange.end) ||
      this.props.site !== prevProps.site;

    if (update) {
      this.update();
    } else if (this.props.category !== prevProps.category) {
      const { originalData } = this.state;
      if (this.props.category === "All") {
        this.setState({
          data: originalData
        });
      } else {
        const filteredData = this.filter(this.props.category, originalData);
        this.setState({
          data: {
            id: originalData.id,
            totalRecordCount: filteredData.length,
            timeResolution: originalData.timeResolution,
            messages: originalData.messages,
            data: {
              content: filteredData,
              localization: originalData.data.localization
            }
          }
        });
      }
    }
  }

  update() {
    const { site, dateRange } = this.props;
    Promise.resolve(MatrixService.getMetrics(dateRange, site)).then(data => {
      if (!data) throw "no data returned by MatrixService";
      this.setState({
        originalData: data,
        data: data
      });
    });
  }

  render() {
    //console.log("matrix render");
    if (!this.state.data) {
      return (
        <MessageBar
          open={true}
          message="Sorry, no data can be found. Please change the filters."
        />
      );
    }

    if (this.state.data.totalRecordCount <= 0) {
      console.warn("no records in dataset");
      return (
        <MessageBar
          open={true}
          message="Sorry, no data can be found. Please change the filters."
        />
      );
    }

    return (
      <PageStatistics
        data={{ pageviews: this.state.data }}
        filters={this.props.filters}
      />
    );
  }
}

export default Matrix;



// WEBPACK FOOTER //
// ./src/containers/Matrix.js